import React, { ReactNode } from 'react';
import { Animated, Modal, TouchableOpacity } from 'react-native';
import { SharedStyles } from '@shared/styles';

const BACKDROP_Z_INDEX = 0; // This needs to be set for touches to be handled correctly on Android

interface Props {
  children: ReactNode;
  onClose(): void;
  opacity: Animated.AnimatedValue;
}

export function MBBottomSheetBackdrop({ children, onClose, opacity }: Props) {
  return (
    <Modal transparent={true} visible animationType="none" onRequestClose={onClose}>
      <Animated.View
        style={[
          SharedStyles.absoluteCover,
          {
            opacity,
            backgroundColor: 'black',
            elevation: BACKDROP_Z_INDEX,
          },
        ]}
      />
      <TouchableOpacity
        onPress={onClose}
        style={{
          flex: 1,
          alignSelf: 'stretch',
          elevation: BACKDROP_Z_INDEX + 1,
        }}
      >
        {children}
      </TouchableOpacity>
    </Modal>
  );
}
